import {lazy} from './lazy.js';
import {doc} from '../docs.js';
import { float} from './utils.js';
import {extractCode} from './extract.js';


doc(
    "gl.fog",
    {
        distance: "",
        amount: "",
    },
    "Creates fog",
    () => 1,
    {
        inlets: 2
    });
export const gl_fog = (object, amount) => {
    return lazy(distance => {
        let codes = extractCode(distance, amount);
        return `1. - exp( -${float(codes[0])} * ${float(codes[1])})`;
    }, amount);
};
